import { render, staticRenderFns } from "./Transportadora.vue?vue&type=template&id=104f358c&scoped=true"
import script from "./Transportadora.vue?vue&type=script&lang=js"
export * from "./Transportadora.vue?vue&type=script&lang=js"
import style0 from "./Transportadora.vue?vue&type=style&index=0&id=104f358c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104f358c",
  null
  
)

export default component.exports